import { Skeleton } from '../Skeleton/Skeleton.js';

export function PageSkeleton() {
  return (
    <div className="p-6 space-y-4" aria-busy="true" aria-label="Cargando página">
      <Skeleton className="h-8 w-48" />
      <Skeleton className="h-4 w-full" />
      <Skeleton className="h-4 w-3/4" />
      <Skeleton className="h-4 w-5/6" />
      <div className="grid grid-cols-3 gap-4 mt-4">
        {Array.from({ length: 6 }).map((_, i) => (
          <Skeleton key={i} className="h-24 rounded-lg" />
        ))}
      </div>
    </div>
  );
}
